import { render, staticRenderFns } from "./2d.vue?vue&type=template&id=4c4034a8&scoped=true&"
import script from "./2d.vue?vue&type=script&lang=js&"
export * from "./2d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4034a8",
  null
  
)

export default component.exports